// Account-level fee-waiver status display gate (SOR-142, R16/R17). Kept
// dependency-free (no workspace imports) so the spec property probes under
// internal/proptests can compile this source directly, mirroring the
// registration wizard's feeWaiverNotice.ts.

/**
 * Local mirror of the `accountFeeWaiver` block on the POST
 * /api/efiling/fees/calculate response (apps/api-gateway/src/features/
 * efiling/account-fee-waiver.ts). The backend type cannot be imported across
 * the app boundary — the same local-interface pattern as CourtFeesTab's
 * EffectiveFeeQuote mirror.
 */
export interface AccountFeeWaiverStatus {
  category: string;
  isFeeWaiverAccount: boolean;
}

/**
 * R16/R17: the account-level status element renders iff the response reports
 * the account as a fee-waiver account — strictly `isFeeWaiverAccount ===
 * true` — so a non-waiver block (false) and an absent block (unset account or
 * account-less caller) both render nothing (I5). Independent of the
 * party-level banner: this gate reads only the account block, never party
 * state.
 */
export function showsAccountFeeWaiverStatus(
  status: AccountFeeWaiverStatus | null | undefined,
): boolean {
  return status?.isFeeWaiverAccount === true;
}
